import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaOverbookingEligibleServicesResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setOverbookingEligibleServices } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useRotaOverbookingEligibleServicesAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    dispatch(setLoading({ key: "isOverbookingEligibleServicesInProgress", status: true }));
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const res: AxiosResponse<IRotaOverbookingEligibleServicesResponse> = await axios.get(
        ROTA_APIS?.ROTA_OVERBOOKING_ELIGIBLE_SERVICES?.baseURL ?? "",
        {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (res.data.status === true) {
        dispatch(
          setOverbookingEligibleServices({
            data: res.data.data ?? [],
          }),
        );
      } else {
        dispatch(
          setOverbookingEligibleServices({
            data: [],
          }),
        );
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        sendCurl?.(error.config?.["curlCommand"]);
        captureError(error);
      } else {
        toast.error("Server Error: " + (error as Error).message);
      }
    } finally {
      dispatch(setLoading({ key: "isOverbookingEligibleServicesInProgress", status: false }));
    }
  }, [configuration, dispatch, captureError, sendCurl]);

  return execute;
};
